import { Checkbox, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';
import { getMessagesForPath } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { getHighestSeverity } from 'Data/ViewModels/Core/Severity';
import { hasValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { FractionTestedOptions } from '../types';

let BsEnResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const selectedFractionTested = useSelector(createWorksheetSelector!('Results.FractionTested'));

  const isSampleWaterTemperatureInRange =
    useSelector(createWorksheetSelector!('Measurements.IsSampleWaterTemperatureInRange')) ?? false;
  const disableReportTestWaterTemperature = useSelector(
    pipe(
      createWorksheetSelector!('Measurements.SampleWaterTemperature'),
      (val) => hasValue(val) && !isSampleWaterTemperatureInRange
    )
  );

  const apparentParticleDensitySeverity = useSelector(
    pipe(createWorksheetSelector!('Results'), (c) =>
      getHighestSeverity(getMessagesForPath(c, 'ApparentParticleDensity').map((a) => a.severity))
    )
  );

  const ovenDriedParticleDensitySeverity = useSelector(
    pipe(createWorksheetSelector!('Results'), (c) =>
      getHighestSeverity(getMessagesForPath(c, 'OvenDriedParticleDensity').map((a) => a.severity))
    )
  );

  const saturatedAndSurfaceDriedParticleDensitySeverity = useSelector(
    pipe(createWorksheetSelector!('Results'), (c) =>
      getHighestSeverity(getMessagesForPath(c, 'SaturatedAndSurfaceDriedParticleDensity').map((a) => a.severity))
    )
  );

  const waterAbsorptionSeverity = useSelector(
    pipe(createWorksheetSelector!('Results'), (c) =>
      getHighestSeverity(getMessagesForPath(c, 'WaterAbsorption').map((a) => a.severity))
    )
  );

  return (
    <>
      <ListFieldSection>
        <Field
          input={<TextOutput />}
          name="Results.FractionTested"
          value={FractionTestedOptions.find((o) => o.value === selectedFractionTested)?.label}
        />
        <Field
          input={<TextOutput />}
          name="Results.ApparentParticleDensity"
          severity={apparentParticleDensitySeverity}
        />
        <Field
          input={<TextOutput />}
          name="Results.OvenDriedParticleDensity"
          severity={ovenDriedParticleDensitySeverity}
        />
        <Field
          input={<TextOutput />}
          name="Results.SaturatedAndSurfaceDriedParticleDensity"
          severity={saturatedAndSurfaceDriedParticleDensitySeverity}
        />
        <Field input={<TextOutput />} name="Results.WaterAbsorption" severity={waterAbsorptionSeverity} />
      </ListFieldSection>

      <ListFieldSection heading="Optional Results">
        <Field input={<TextOutput />} name="Results.TestPortionMass" />
        <Field input={<TextOutput />} name="Results.TestWaterTemperature" />
      </ListFieldSection>

      <ListFieldSection heading="Report">
        <FieldSet>
          <Field input={<Checkbox />} name="Results.ReportTestPortionMass" />
          <Field
            input={<Checkbox />}
            name="Results.ReportTestWaterTemperature"
            disabled={disableReportTestWaterTemperature}
          />
        </FieldSet>
      </ListFieldSection>
      <WorksheetsResultsMessagesSection />
    </>
  );
};

BsEnResultsSection = withInjectedProps(BsEnResultsSection);

export { BsEnResultsSection };
export default BsEnResultsSection;
